import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-perevoruj',
  templateUrl: './perevoruj.component.html',
  styleUrls: ['./perevoruj.component.scss']
})
export class PerevorujComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
